// Module
var code = "<div id=\"rubric-widget-text-element\" data-cy=\"text-element\" class=\"rb-widget rb-text\"><div class=\"rb-avatar\" translate=\"rubric-widget-text_text-response\"></div></div>";
// Exports
module.exports = code;